var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBillingDetails = function SvgBillingDetails(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "107px",
    height: "110px",
    viewBox: "0 0 107 110",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Billing details")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Billing-details",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-1",
    fill: "#FFFFFF",
    points: "0.0002 108.7427 0.0002 14.1297 91.6012 14.1297 91.6012 108.7427"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-2",
    stroke: "#201574",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "0.0002 108.7427 0.0002 14.1297 91.6012 14.1297 91.6012 108.7427"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-4",
    fill: "#FFFFFF",
    points: "91.6008 108.7427 82.4418 102.7427 73.2838 108.7427 64.1258 102.7427 54.9698 108.7427 45.8128 102.7427 36.6538 108.7427 27.4918 102.7427 18.3308 108.7427 9.1658 102.7427 -0.0002 108.7427"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-5",
    stroke: "#201574",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "91.6008 108.7427 82.4418 102.7427 73.2838 108.7427 64.1258 102.7427 54.9698 108.7427 45.8128 102.7427 36.6538 108.7427 27.4918 102.7427 18.3308 108.7427 9.1658 102.7427 -0.0002 108.7427"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-7",
    fill: "#FFFFFF",
    points: "91.6008 108.7427 82.4418 102.7427 73.2838 108.7427 64.1258 102.7427 54.9698 108.7427 45.8128 102.7427 36.6538 108.7427 27.4918 102.7427 18.3308 108.7427 9.1658 102.7427 -0.0002 108.7427"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-8",
    stroke: "#201574",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "91.6008 108.7427 82.4418 102.7427 73.2838 108.7427 64.1258 102.7427 54.9698 108.7427 45.8128 102.7427 36.6538 108.7427 27.4918 102.7427 18.3308 108.7427 9.1658 102.7427 -0.0002 108.7427"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.6526,
    y1: 31.732,
    x2: 15.0166,
    y2: 31.732,
    id: "Stroke-10",
    stroke: "#201574",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.5842,
    y1: 45.5474,
    x2: 15.0172,
    y2: 45.5474,
    id: "Stroke-11",
    stroke: "#201574",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.5842,
    y1: 59.3628,
    x2: 15.0172,
    y2: 59.3628,
    id: "Stroke-12",
    stroke: "#201574",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.5842,
    y1: 73.1792,
    x2: 15.0172,
    y2: 73.1792,
    id: "Stroke-13",
    stroke: "#201574",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.5842,
    y1: 86.9947,
    x2: 15.0172,
    y2: 86.9947,
    id: "Stroke-14",
    stroke: "#201574",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(59.000000, 0.743000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.342,23.532 C47.342,36.386 36.921,46.807 24.066,46.807 C11.211,46.807 0.79,36.386 0.79,23.532 C0.79,10.678 11.211,0.257 24.066,0.257 C36.921,0.257 47.342,10.678 47.342,23.532",
    id: "Fill-15",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.342,23.532 C47.342,36.386 36.921,46.807 24.066,46.807 C11.211,46.807 0.79,36.386 0.79,23.532 C0.79,10.678 11.211,0.257 24.066,0.257 C36.921,0.257 47.342,10.678 47.342,23.532 Z",
    id: "Stroke-17",
    stroke: "#201574",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "\\xA3",
    fillRule: "nonzero",
    fontFamily: "LexendDeca-Regular, Lexend Deca",
    fontSize: 24,
    fontWeight: "normal",
    "line-spacing": 28,
    fill: "#201574"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 75,
    y: 33
  }, "\xA3")))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBillingDetails, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/billingDetails.b781d4fe.svg";
export { ForwardRef as ReactComponent };